// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader, { OrderHeaderStyles } from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";

export interface OnePageCheckoutHeaderProps extends WidgetProps {}

export interface OnePageCheckoutHeaderStyles {
    orderHeader?: OrderHeaderStyles;
}

export const onePageCheckoutHeaderStyles: OnePageCheckoutHeaderStyles = {};

const styles = onePageCheckoutHeaderStyles;

const OnePageCheckoutHeader: FC<OnePageCheckoutHeaderProps> = ({ id }) => {
    const currentPage = useCurrentPage();
    const linkBack = usePageLinkByPageType(constants.pageType.cart);

    return (
        <OrderHeader
            extendedStyles={styles.orderHeader}
            title={currentPage.fields.title}
            contentId={id}
            linkBack={linkBack}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutHeader,
    definition: {
        displayName: "Page Header",
        group: "One Page Checkout",
        allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;
